import { Menu, MenuButton, MenuItem, MenuList, MenuPopover, MenuTrigger, SearchBox } from "@fluentui/react-components";
import React, { useContext, useEffect, useRef, useState } from "react";
import { selectTenantUrl } from "../redux/selectors/authSelector";
import { useReduxSelector } from "../redux/hooks/hooks";
import { Link } from "react-router-dom";
import { userApi } from "../redux/api/userApi";
import { TeamsFxContext } from "./Context";
const fluent = require("@fluentui/react");

type HeaderBarProps = {
    fullSiteUrl: string;
    onLogout: () => void;
    avatarSrc?: string;
    userName?: string;
    className?: string;
    filter?: string;
    onfilterChange?: (newValue: string) => void;
};

export default function HeaderBar({
    fullSiteUrl,
    onLogout,
    avatarSrc,
    userName,
    className,
    filter,
    onfilterChange
}: HeaderBarProps) {

    const { themeString } = useContext(TeamsFxContext);
    const { data: profile } = userApi.useGetProfileQuery();
    const tenantUrl = useReduxSelector(selectTenantUrl);
    const [open, setOpen] = useState(false);
    const rootRef = useRef<HTMLDivElement | null>(null);
    const buttonRef = useRef<HTMLButtonElement | null>(null);

    useEffect(() => {
        function onDocumentClick(e: MouseEvent | TouchEvent) {
            if (!rootRef.current) return;
            if (!rootRef.current.contains(e.target as Node)) setOpen(false);
        }
        function onKey(e: KeyboardEvent) {
            if (e.key === "Escape") setOpen(false);
        }
        document.addEventListener("pointerdown", onDocumentClick);
        document.addEventListener("keydown", onKey);
        return () => {
            document.removeEventListener("pointerdown", onDocumentClick);
            document.removeEventListener("keydown", onKey);
        };
    }, []);

    const tenantRef = useRef<HTMLAnchorElement | null>(null);

    return (
        <nav className="navbar navbar-expand-lg bg-body-tertiary">
            <div className="container-fluid">
                <Link to={fullSiteUrl} className="navbar-brand d-flex align-items-center text-decoration-none" target="_blank" rel="noopener noreferrer">
                    <img
                        src={true ? '/images/revelation_logo_dark.png' : '/images/revelation_logo.png'}
                        alt={'Revelation helpdesk'}
                        style={{ height: 32, display: "block", objectFit: "contain" }}
                    />
                </Link>
                <div className="align-items-center flex-grow-1" id="navbarSupportedContent">
                    <div className="d-flex flex-grow-1 justify-content-end" role="search">
                        <SearchBox className="flex-grow-1 m-1" placeholder="Search..." value={filter} onChange={(e, newValue) => onfilterChange && onfilterChange(newValue?.value || "")} />
                        {userName && <Menu>
                            <MenuTrigger>
                                <MenuButton appearance="transparent" shape="square" style={{ border: 'none' }} >
                                    {avatarSrc ? (
                                        <img title={userName}
                                            src={avatarSrc}
                                            alt={userName ? `${userName} avatar` : "User avatar"}
                                            className="rounded-circle border"
                                            style={{ width: 36, height: 36, objectFit: "cover" }}
                                        />
                                    ) : (
                                        <div
                                            className="rounded-circle bg-secondary text-white d-inline-flex align-items-center justify-content-center"
                                            style={{ width: 36, height: 36, fontWeight: 600 }}
                                        >
                                            {userName ? userName.split(" ").map(word => word.charAt(0).toUpperCase()).join("") : "U"}
                                        </div>
                                    )}

                                </MenuButton>
                            </MenuTrigger>
                            <MenuPopover>
                                <MenuList>
                                    <MenuItem onClick={() => { tenantRef?.current?.click(); }}>
                                        <h5>{userName}</h5>
                                        <h6>{profile && profile?.Company_Name}</h6>
                                        <div><Link ref={tenantRef} target="_blank" className="nav-link" to={tenantUrl!}>{tenantUrl}</Link></div>
                                    </MenuItem>
                                    <MenuItem onClick={onLogout}>Sign out</MenuItem>
                                </MenuList>
                            </MenuPopover>
                        </Menu>}
                    </div>
                </div>
            </div>
        </nav>
    )


}
declare const require: any;

(() => {
    // Try to initialize Fluent UI icons and apply a simple theme (safe to fail)
    try {
        fluent.initializeIcons?.();
        fluent.loadTheme?.({
            palette: {
                themePrimary: "#0078d4",
                neutralLight: "#f3f2f1",
                neutralLighter: "#faf9f8",
                neutralQuaternaryAlt: "#e1dfdd",
                neutralPrimary: "#323130",
                white: "#ffffff",
            },
        });
    } catch {
        // ignore if Fluent UI isn't available at runtime
    }

    // Inject lightweight Fluent-like CSS to restyle the existing markup
    const css = `
        :root{
            --fluent-primary: #0078d4;
            --fluent-neutralPrimary: #323130;
            --fluent-neutralLighter: #faf9f8;
            --fluent-neutralQuaternaryAlt: #e1dfdd;
            --fluent-bg: #ffffff;
        }

        /* Header background / brand */
        .navbar-brand {
            color: var(--fluent-neutralPrimary) !important;
            font-weight: 600;
            display: inline-flex;
            align-items: center;
            gap: 8px;
        }
        .navbar-brand img { height: 32px; width: auto; object-fit: contain; }

        /* Replace Bootstrap btn-light with Fluent neutral outline button look */
        .btn.btn-light {
            background: transparent;
            border: 1px solid var(--fluent-neutralQuaternaryAlt);
            color: var(--fluent-neutralPrimary);
            box-shadow: none;
            border-radius: 4px;
            padding: 6px 8px;
        }
        .btn.btn-light:hover {
            background: var(--fluent-neutralLighter);
            border-color: var(--fluent-primary);
            color: var(--fluent-primary);
        }

        /* Avatar visuals */
        .rounded-circle {
            border-radius: 50% !important;
        }
        .rounded-circle.border { border: 1px solid var(--fluent-neutralQuaternaryAlt) !important; }
        .bg-secondary {
            background: var(--fluent-primary) !important;
            color: var(--fluent-bg) !important;
        }

        /* Dropdown (contextual menu) */
        .dropdown-menu {
            background: var(--fluent-bg);
            border: 1px solid var(--fluent-neutralQuaternaryAlt);
            box-shadow: 0 4px 12px rgba(0,0,0,0.08);
            border-radius: 4px;
            padding: 6px 0;
            font-size: 14px;
            color: var(--fluent-neutralPrimary);
            overflow: hidden;
        }
        .dropdown-menu .dropdown-item {
            padding: 8px 12px;
            display: block;
            color: var(--fluent-neutralPrimary);
            text-decoration: none;
            background: transparent;
            border: none;
            width: 100%;
            text-align: left;
        }
        .dropdown-menu .dropdown-item:hover {
            background: var(--fluent-neutralLighter);
            color: var(--fluent-primary);
        }
        .dropdown-menu .dropdown-item.text-danger { color: #d13438; }
        .dropdown-menu.show { transform-origin: top right; }

        /* Small tweaks for spacing & typography */
        .fs-6 { font-size: 14px !important; }
        .me-2 { margin-right: .5rem !important; }
        .gap-2 { gap: .5rem; }
        .p-2 { padding: .5rem !important; }
        .border-bottom { border-bottom: 1px solid var(--fluent-neutralQuaternaryAlt) !important; }
        .bg-white { background: var(--fluent-bg) !important; }

        /* Ensure menu appears above Teams frame */
        .dropdown-menu { z-index: 99999 !important; }
    `;

    if (typeof document !== "undefined") {
        const existing = document.querySelector('style[data-generated-by="fluent-headerbar-styles"]');
        if (!existing) {
            const style = document.createElement("style");
            style.setAttribute("data-generated-by", "fluent-headerbar-styles");
            style.appendChild(document.createTextNode(css));
            document.head.appendChild(style);
        }
    }
})();